import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 px-4 md:px-6 py-3 max-w-7xl mx-auto overflow-x-auto whitespace-nowrap">
      <Link to="/" className="hover:text-primary-500 transition-colors duration-200 flex items-center gap-1 shrink-0">
        <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
        <span>首页</span>
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center shrink-0">
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center mx-1 text-foreground-400"></i>
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-500 transition-colors duration-200">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}